// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X8j1","content":"styles_content__bOdaA"};